function read(value: string | undefined, fallback: string): string {
  return value === undefined || value === "" ? fallback : value;
}

const API_URL = read(import.meta.env["BSMEET_PUBLIC_API_URL"], "http://localhost:8080");

export const env = {
  appName: read(import.meta.env["BSMEET_PUBLIC_APP_NAME"], "BS Meet"),

  apiOrigin: API_URL.replace(/\/+$/u, ""),

  cdnUrl: read(import.meta.env["BSMEET_PUBLIC_CDN_URL"], `${API_URL.replace(/\/+$/u, "")}/cdn`),

  siteUrl: read(import.meta.env["BSMEET_PUBLIC_SITE_URL"], ""),
} as const;

export function apiBase(): string {
  return `${env.apiOrigin}/api`;
}

export function socketOrigin(): string {
  return env.apiOrigin.replace(/^http/u, "ws");
}

export function siteOrigin(): string {
  if (env.siteUrl !== "") return env.siteUrl.replace(/\/+$/u, "");
  return globalThis.location.origin;
}

export function cdnUrl(path: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${env.cdnUrl.replace(/\/+$/u, "")}/${path.replace(/^\/+/u, "")}`;
}
